import { gql, useMutation } from '@phoenix-web/ux-gql/apollo'

export type LeadInfoBody = {
  email: string
  lead_id?: string
  first_name: string
  last_name: string
  notification_preference?: string
  invitation_token?: string
  phone_number: string
  audience: string
  terms_of_service: boolean
  privacy_policy_consent: boolean
  states?: string[]
}

const SAVE_LEAD_INFO_TO_CACHE = gql`
  mutation saveLeadInfoToCache($input: LeadInfoBody!) {
    saveLeadInfoToCache(input: $input) {
      success
    }
  }
`

export const useSaveLeadInfoToCache = ({ skip: _skip = false }: { skip?: boolean } = {}) => {
  const query = useMutation(SAVE_LEAD_INFO_TO_CACHE, { fetchPolicy: 'no-cache', context: { clientName: 'public' } })
  return query
}
